"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @flow
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const url_1 = __importDefault(require("url"));
const live_env_1 = require("@ledgerhq/live-env");
const api = {
    getBlockCount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${(0, live_env_1.getEnv)("API_TEZOS_TZKT_API")}/v1/blocks/count`,
            });
            return data;
        });
    },
    getAccountByAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: `${(0, live_env_1.getEnv)("API_TEZOS_TZKT_API")}/v1/accounts/${address}`,
            });
            return data;
        });
    },
    getAccountOperations(address, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: url_1.default.format({
                    pathname: `${(0, live_env_1.getEnv)("API_TEZOS_TZKT_API")}/v1/accounts/${address}/operations`,
                    query,
                }),
            });
            return data;
        });
    },
};
exports.default = api;
//# sourceMappingURL=tzkt.js.map